<template>
  <Result :title="title" :state="state" :message="message"/>
</template>

<script>
import * as R from 'ramda'
import moment from 'moment-timezone'
import Result from '@/components/Results/ResultBase.vue'
import { STATE } from '@/constants.js'
export default {
  name: 'ResultOfTimeZone',
  props: {
    timeZoneSettings: {
      type: Object,
      required: true
    }
  },
  components: {
    Result
  },
  data () {
    return {
      title: 'タイムゾーン',
      timeZone: {
        id: ''
      }
    }
  },
  computed: {
    message () {
      return R.equals(this.timeZone.id, this.timeZoneSettings.id)
        ? this.timeZoneSettings.success
        : this.timeZoneSettings.failed
    },
    state () {
      return R.equals(this.timeZone.id, this.timeZoneSettings.id)
        ? STATE.OK
        : STATE.WARN
    }
  },
  async created () {
    // タイムゾーン https://momentjs.com/timezone/docs/#/using-timezones/guessing-user-timezone/
    this.timeZone.id = moment.tz.guess(true)
  }
  
}
</script>

<style>

</style>
